import { AdminAttendeeStatusType } from './shared';

export const adminEvent = (params: { eventId: number }) => `event:${params.eventId}`;

export const adminAttendees = (params: { eventId: number; attendee_status: AdminAttendeeStatusType }) =>
  `event:${params.eventId},status:${params.attendee_status}`;

export const adminAttendeeTickets = (params: { s: string }) => `s:${params.s}`;
